var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"c2689febee9df984b6211664438dcb18e57f82ee"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["kubera-frontend@kubera"]={id:"c2689febee9df984b6211664438dcb18e57f82ee"};
      